<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item }">
                            <tr :id="'r-' + item.ID">
                                <td>{{ item.ID }}</td>
                                <td>{{ item.UserCode }}</td>
                                <td>{{ item.Username }}</td>
                                <td class="text-end">{{ item.NumberOfPack | currency }}</td>
                                <td class="text-end">{{ item.Weight | currency('', 2) }}</td>
                                <td class="text-end">{{ item.Volume | currency('', 2) }}</td>
                                <td v-bind:style="{ 'color': get_status_color(item.Status, receipt_status)}">{{ item.Status | display_value(receipt_status) }}</td>
                                <td>{{ item.CreatedDate | display_date('DD-MM-YYYY')}} <br /> {{ item.CreatedDate | display_date('HH:mm:ss')}} </td>
                                <td class="text-center">
                                    <v-icon medium class="mr-2 mb-2" data-toggle="tooltip" title="Hủy xuất kho" :disabled="item.Status != 1 && !adminRole" @click="backward(item)">fa-undo</v-icon>
                                    <v-icon medium class="mr-2 mb-2" @click="gotoDetail(item)">fa-edit</v-icon>
                                    <!-- <v-icon medium class="mr-2 mb-2" @click="deleteItem(item.ID)" :disabled="item.Status == 1 && !adminRole">fa-trash-alt</v-icon> -->
                                </td>
                            </tr>
                        </template>
                        <template v-slot:body.append v-if="summary">
                            <tr class="total-summary-td">
                                <td colspan="3" class="text-center font-weight-bold">Tổng</td>
                                <td class="text-end font-weight-bold">{{ summary.NumberOfPack | currency}}</td>
                                <td class="text-end font-weight-bold">{{ summary.Weight | currency('', 1) }}</td>
                                <td class="text-end font-weight-bold">{{ summary.Volume | currency('', 2) }}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialogReceipt" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card>
            <v-toolbar dark color="oee-theme">
                <v-btn icon dark @click="dialogReceipt = false">
                  <v-icon>fa-times-circle</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-toolbar-title>Phiếu xuất kho #{{selectedItem.ID > 0 ? selectedItem.ID : 'Tạo mới'}}</v-toolbar-title>
            </v-toolbar>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1 white--text"  class="mt-8 mr-2" @click="printDetail">In phiếu</v-btn>
                <v-btn color="green darken-1 white--text"  class="mt-8 mr-2" v-if="selectedItem.Status == 0" @click="saveItem({ID: selectedItem.ID, Status: 1})">Xuất kho</v-btn>
                <v-btn color="blue darken-1 white--text"  class="mt-8 mr-2" v-if="selectedItem.Status == 0" @click="saveItem({ID: selectedItem.ID, Receiver: selectedItem.Receiver, Phone: selectedItem.Phone, ShippingMethod: selectedItem.ShippingMethod, Address: selectedItem.Address})">Cập nhật</v-btn>
            </v-card-actions>
            <v-card-text>
              <v-container grid-list-xl fluid>
                <v-layout row wrap>
                  <v-flex lg4 md4 sm12>
                    <v-text-field label="Tên người nhận" v-model="selectedItem.Receiver"></v-text-field>  
                  </v-flex>
                  <v-flex lg4 md4 sm12>
                    <v-text-field label="Số điện thoại" v-model="selectedItem.Phone"></v-text-field>
                  </v-flex>
                  <v-flex lg4 md4 sm12>
                    <v-text-field label="Hình thức ship" v-model="selectedItem.ShippingMethod"></v-text-field>
                  </v-flex>
                  <v-flex lg12 md12 sm12 xs12>
                    <v-text-field label="Địa chỉ nhận" v-model="selectedItem.Address"></v-text-field>
                  </v-flex>
    
                  <v-flex lg4 md4 sm12>
                    <v-text-field readonly label="Số kiện" type="number" v-model="selectedItem.NumberOfPack"></v-text-field>
                  </v-flex>
                  <v-flex lg4 md4 sm12>
                    <h-currency-input v-model="selectedItem.Weight" label="Tổng cân" :decimal="1" readonly></h-currency-input>
                  </v-flex>
                  <v-flex lg4 md4 sm12>
                    <h-currency-input v-model="selectedItem.Volume" label="Tổng khối" :decimal="2" readonly></h-currency-input>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex lg12 pt-0>
                        <v-card>
                            <v-data-table :headers="package_headers" :items="orderTransactions" :options.sync="package_pagination" :server-items-length="orderTransactions ? orderTransactions.length : 0" :must-sort="true" :mobile-breakpoint="100">
                                <template v-slot:item="{ item }">
                                    <tr :id="'r-' + item.ID" v-bind:class="{'bill-checked': chkCheckBill && item.Matched}">
                                        <td>{{ item.TransactionCode }}</td>
                                        <td><a target="_blank" :href="(item.PackageType == 1 ? '/ky-gui/' : '/don-hang/') + item.OrderID">{{ item.OrderCode }}</a></td>
                                        <td>{{ item.Weight | currency('', 2) }}</td>
                                        <td>{{ item.Volume | currency('', 2) }}</td>
                                        <td v-bind:style="{ 'color': get_status_color(item.Status, package_status)}">{{ item.Status | display_value(package_status) }}</td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
    </v-container>
    </template>
    
    <script>
    import { mapState } from "vuex";
    import configs from "@/configs";
    import Filtering from "@/components/Filtering";
    import { sendErrorNotice, sendSuccessNotice, refreshResource, playSound } from '@/commons/utils';
    import { request_list, print_export_receipt_order } from '@/commons/hpod';
    import Vue from 'vue';
    import _ from "lodash";
    
    export default {
        components: {
            "hpo-filter": Filtering
        },
        data() {
            return {
                headers: [
                    {
                        text: "Mã phiếu",
                        value: "ID",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Mã khách",
                        value: "UserCode",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Khách hàng",
                        value: "Username",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Số kiện",
                        value: "NumberOfPack",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Tổng cân",
                        value: "Weight",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Tổng khối",
                        value: "Volume",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Trạng thái",
                        value: "Status",
                        filterable: true,
                        values: configs.EXPORT_RECEIPT_STATUS,
                        dataType: configs.DATA_TYPE["Enum"]
                    },
                    {
                        text: "Ngày tạo",
                        value: "CreatedDate",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Date"]
                    },              
                    {
                        text: "Thao tác",
                        value: "",
                        align: "center",
                        sortable: false,
                        filterable: false
                    }
                ],
                package_headers: [
                    {
                        text: "Mã bill",
                        value: "TransactionCode",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Mã đơn hàng",
                        value: "OrderID",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Cân nặng",
                        value: "Weight",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Khối",
                        value: "Volume",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Trạng thái",
                        value: "Status",
                        filterable: true,
                        values: configs.PACKAGE_STATUS,
                        dataType: configs.DATA_TYPE["Enum"]
                    }
                ],
                dialogReceipt: false,
                useInternalCode: false,
                chkCheckBill: false,
                totalMatched: 0,
                package_status: configs.PACKAGE_STATUS,
                receipt_status: configs.EXPORT_RECEIPT_STATUS,
                order_type_list: configs.ORDER_TYPE_LIST,
                pagination: {  ...configs.PAGINATION,  sortBy: ["ID"]  },
                package_pagination: {  ...configs.PAGINATION,  sortBy: ["ID"], itemsPerPage: -1 },
                items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
                viewName: "exportreceipt_list",
                filterConditions: [],
                quickFilterConditions: [],
                requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
                selectedItem: {},
                newTransactionCode: '',
                newTransactionCodeVN: '',
                internalMessage: '',
                isDepositOrder: configs.SYSTEM_TYPE != 'order',
                bigpackageCode: ''
            };
        },
        watch: {
            pagination: {
                handler: function (val, oldVal) {
                    let filterConditions = this.$store.state.commons.filterConditions;
                    this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                    this.filter_data();
                },
                deep: true
            },
            items() {
                if(this.dialogReceipt && this.selectedItem.ID) {
                   let item = _.find(this.items, {'ID': this.selectedItem.ID});
                   this.selectedItem = item;
                }
            },
            dialogReceipt() {
                if(!this.dialogReceipt){
                    this.selectedItem = {};
                    this.totalMatched = 0;
                    this.chkCheckBill = false;
                }
            }
        },
        computed: {
            ...mapState({
                items: state => state.exportReceipt.all.data,
                total_rows: state => state.exportReceipt.all.total,
                summary: state => state.exportReceipt.all.summary,
                loading: state => state.exportReceipt.loading,
                orderTransactions: state => state.orderTransaction.all.data,
                configuration: state => state.configuration.selected
            }),
            adminRole() {
                return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
            },
            tableConfig() {
                return {
                    pagination: this.pagination,
                    filter: this.filterConditions,
                    quickFilter: this.quickFilterConditions
                }
            },
        },
        methods: {
            filter_data: function () {
                this.$store.dispatch("exportReceipt/getList", this.tableConfig);
                if(this.dialogReceipt) {
                    this.getTransactionOfReceipt();
                }
            },
            applyFilter(filterConditions) {
                let sortBy = this.pagination.sortBy
                let sortDesc = this.pagination.sortDesc
                this.pagination = configs.PAGINATION;
                this.pagination.sortBy = sortBy;
                this.pagination.sortDesc = sortDesc;
                this.filterConditions = filterConditions;
                this.filter_data();
            },
            quickFilter(filterConditions) {
                this.quickFilterConditions = filterConditions;
                this.filter_data();
            },
            get_status_color(val, enums) {
                return this.$options.filters.display_color(val, enums);
            },
            getTransactionOfReceipt() {
                if(this.selectedItem.ID > 0) {
                    var param={
                        filter: [
                        {
                            column: "ReceiptID",
                            value: this.selectedItem.ID,
                            condition: "equal"
                        }
                        ]
                    };
                    this.$store.dispatch("orderTransaction/getList", param);
                }            
            },
            createData() {
                this.selectedItem = {
                    ID: 0,
                    UID: 0,
                    Status: 0
                };
                this.$store.commit("orderTransaction/setList", {data: [], total: 0});
                this.dialogReceipt = true;
            },
            gotoDetail(item) {
                this.selectedItem = item;
                this.getTransactionOfReceipt();
                this.dialogReceipt = true;
            },
            backward(item) {
                this.$store.dispatch("exportReceipt/setDetail", {
                    data: {Status: 0},
                    id: item.ID
                });
            },
            printDetail() {
                const frame_printing = print_export_receipt_order({...this.selectedItem, Voter: this.$store.state.authentication.user.fullname}, this.orderTransactions, true);
                var doc = document.getElementById('print_frame').contentWindow.document;
                doc.open();
                doc.write(frame_printing);
                doc.close();
                setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
            },
            deleteItem(id) {
                window.getApp.$emit('REQUEST_DELETE_DATA', id);
            },
            saveItem(item) {
                this.$store.dispatch("exportReceipt/setDetail", {
                    data: item,
                    id: item.ID
                });
            }
        },
        mounted() {
            this.$store.dispatch("configuration/getDetail", 1);
            this.$root.$emit('REQUEST_ROOT_OPTION', {});
            this.$root.$on("REQUEST_CREATE_DATA", this.createData);
            this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        },
        beforeDestroy() {
            this.$root.$off("REQUEST_CREATE_DATA", this.createData);
            this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        }
    };
    </script>
    <style scoped>
    .bill-checked{
        background-color: rgb(1, 187, 125);
    }
    </style>